import { throttle } from 'lodash';

let $cards = $('.card2');
let $window = $(window);

$window.on('resize', throttle(() => {
    $cards.each((i, e) => {
        let $line = $(e).find('.card2-line');
        let $image = $(e).find('.card2-image');
        $line.css('top', $image.outerHeight() - 25 + 'px');
    });
}, 100)).trigger('resize');